module.exports = __webpack_public_path__ + "cyclist.jpg?3722c19e2425a016fdd050e57f487125";